import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { CancelBackgroundJob, OpenCancelBackgroundJobDialog, ToggleBackgroundJobExtendedInfoDialog } from '../../bootstrap/redux/actions/AppActionTypes';
import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { CancelBackgroundJobAction } from '../actions/CancelBackgroundJobAction';
import { OpenCancelBackgroundJobDialogAction } from '../actions/OpenCancelBackgroundJobDialogAction';
import { ToggleBackgroundJobExtendedInfoDialogAction } from '../actions/ToggleBackgroundJobExtendedInfoDialog';
import { BackgroundJobExtendedInfoDialog } from '../components/BackgroundJobExtendedInfoDialog';
import { CancelBackgroundJobDialog } from '../components/CancelBackgroundJobDialog';
import { BackgroundJobsService } from '../types/BackgroundJobs';
import { ICancelBackgroundJobParams } from '../types/CancelBackgroundJobRequest';


export function* openCancelBackgroundJobDialog(action: OpenCancelBackgroundJobDialogAction) {
  try {
    yield call(CancelBackgroundJobDialog.open, action.backgroundJob);
  } catch (e) {
    yield put(requestFailed(e, Messages.backgroundJobCancelFailed()));
  }
}

export async function cancelBackgroundJobAsyncHelper(params: ICancelBackgroundJobParams) {
  return await BackgroundJobsService.cancelBackgroundJob(params);
}

export function popToastNotificationForBackgroundJobCancellation(sucessfull: boolean) {
  const service = ToasterService.instance;
  if (sucessfull) {
    service.pop({
      text: Messages.backgroundJobCancelSuccessful(),
      type: ToastType.Info,
    });
  } else {
    service.pop({
      text: Messages.backgroundJobCancelFailed(),
      type: ToastType.Error,
    });
  }
}

export function* cancelBackgroundJob(action: CancelBackgroundJobAction) {
  const result = yield call(cancelBackgroundJobAsyncHelper, action.params);
  const errored = result.errors && result.errors.length > 0;
  yield call(popToastNotificationForBackgroundJobCancellation, !errored);
  yield put(requestSpaceContents());
}

export function* toggleBackgroundJobExtendedInfoDialog(action: ToggleBackgroundJobExtendedInfoDialogAction) {
  yield call(BackgroundJobExtendedInfoDialog.toggle, action.backgroundJob);
}

export function* rootBackgroundJobSaga(): SagaIterator {
  yield takeEvery(OpenCancelBackgroundJobDialog, openCancelBackgroundJobDialog);
  yield takeEvery(CancelBackgroundJob, cancelBackgroundJob);
  yield takeEvery(ToggleBackgroundJobExtendedInfoDialog, toggleBackgroundJobExtendedInfoDialog);
}
